import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Drop-in replacement for PrimeNG's p-skeleton.
 *
 * MIGRATION: only the tag name changes.
 *   <p-skeleton width="100%" height="14px" borderRadius="4px" />
 *   becomes
 *   <app-skeleton width="100%" height="14px" borderRadius="4px" />
 *
 * All attributes (width, height, borderRadius, styleClass) work unchanged.
 */
@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div
      class="app-skeleton"
      [ngClass]="styleClass"
      [style.width]="width"
      [style.height]="height"
      [style.border-radius]="borderRadius"
    ></div>
  `,
})
export class AppSkeletonComponent {
  @Input() width: string = '100%';
  @Input() height: string = '1rem';
  @Input() borderRadius: string = '4px';
  @Input() styleClass: string = '';
}